import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, USER_ROLES } from '../../context/AuthContext';
import { fetchStudentById } from '../../services/studentService';
import Layout from '../layout/Layout';
import './StudentProfile.css';

const StudentProfile = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const MAX_RETRIES = 3;
    const RETRY_DELAY = 2000;
    
    const getStudentProfile = async () => {
      if (!currentUser) return;
      
      try {
        console.log(`Attempting to fetch student profile (attempt ${retryCount + 1}/${MAX_RETRIES + 1})`);
        const studentData = await fetchStudentById(currentUser.uid);
        setStudent(studentData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching student profile:', err);
        
        if (retryCount < MAX_RETRIES) {
          console.log(`Retrying in ${RETRY_DELAY}ms...`);
          setTimeout(() => {
            setRetryCount(prev => prev + 1);
          }, RETRY_DELAY);
        } else {
          setError('プロフィール情報の取得に失敗しました。ページを再読み込みしてください。');
          setLoading(false);
        }
      }
    };

    getStudentProfile();
  }, [currentUser, retryCount]);

  useEffect(() => {
    if (!loading && !student && userRole === USER_ROLES.STUDENT) {
      const redirectTimer = setTimeout(() => {
        console.log('Redirecting to home page due to missing student data');
        navigate('/');
      }, 5000);
      
      return () => clearTimeout(redirectTimer);
    }
  }, [loading, student, navigate, userRole]);

  if (loading) return <div className="loading">読み込み中...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!student) return <div className="error">プロフィール情報が見つかりません。ホームページに戻ります...</div>;

  return (
    <Layout>
      <div className="profile-container">
        <h2 className="profile-heading">マイプロフィール</h2>
        <div id="student-detail">
          <div className="profile-header">
            <div className="student-icon">
              <i className="fas fa-user-graduate" style={{ fontSize: '3rem', color: 'var(--accent-color)' }}></i>
            </div>
            <h1 className="student-name">{student.氏名}</h1>
          </div>
          <table>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "75%" }} />
            </colgroup>
            <tbody>
              <tr><th colSpan={2} id="section">プロフィール</th></tr>
              <tr><th>氏名</th><td className="student-name-table">{student.氏名}</td></tr>
              <tr><th>在籍大学</th><td className="university">{student.在籍大学}</td></tr>
              <tr><th>学年</th><td className="grade">{student.学年}</td></tr>
              <tr><th>連絡先</th><td className="contact">{student.連絡先}</td></tr>
              {(student.志望業界 || student.志望職種) && (
                <>
                  <tr><th colSpan={2} id="section">志望情報</th></tr>
                  {student.志望業界 && (
                    <tr><th>志望業界</th><td className="desired-industry">{student.志望業界}</td></tr>
                  )}
                  {student.志望職種 && (
                    <tr><th>志望職種</th><td className="desired-job">{student.志望職種}</td></tr>
                  )}
                </>
              )}
              {student.自己紹介 && (
                <>
                  <tr><th colSpan={2} id="section">自己紹介</th></tr>
                  <tr><th>自己紹介</th><td className="self-introduction">{student.自己紹介}</td></tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        
        <div className="profile-actions">
          <Link to="/student-profile/edit" className="edit-button">
            プロフィールを編集
          </Link>
        </div>
      </div>
      <div className="navigation-buttons">
        <Link to="/mentors-list" className="nav-button">
          OG一覧を見る
        </Link>
      </div>
    </Layout>
  );
};

export default StudentProfile;